<div class="toolbar">
  <p-button label="Nuevo informe" icon="pi pi-plus" (click)="newReport()"></p-button>
  <p-button label="Eliminar seleccionados" severity="danger" (click)="deleteSelected()" *ngIf="selectedReports?.length"></p-button>
</div>

<p-table [value]="records$ | async" styleClass="p-datatable-striped" sortMode="single" [(selection)]="selectedReports" dataKey="id">
  <ng-template pTemplate="header">
    <tr>
      <th id="select-column" style="width: 4rem"></th>
      <th id="title-column" pSortableColumn="title">Título <p-sortIcon field="title"></p-sortIcon></th>
      <th id="width-column" pSortableColumn="width">Ancho <p-sortIcon field="width"></p-sortIcon></th>
      <th id="height-column" pSortableColumn="height">Alto <p-sortIcon field="height"></p-sortIcon></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-record>
    <tr [pSelectableRow]="record">
      <td>
        <div class="row-buttons">
          <p-tableCheckbox [value]="record"></p-tableCheckbox>
          <button pButton pRipple type="button" icon="pi pi-pencil" (click)="onRowEdit(record)"
            class="p-button-rounded p-button-text"></button>
        </div>
      </td>
      <td>{{ record.title }}</td>
      <td>{{ record.width }}{{record.widthUnit}}</td>
      <td>{{ record.height }}{{record.heightUnit}}</td>
    </tr>
  </ng-template>
</p-table>
